import type { Cart } from "@server/gql/graphql";

/**
 * We ditch estimated shipping for now (freight classes are unreliable)
 */
export default function getShippingCost({ cart }: { cart?: Cart | null }) {
  return cart?.totalFreightInclVat ?? 0;
}
